import React from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-bootstrap'
import { userRegionIsUS, userRegionIsEU } from '../../../functions/userPermissions'

import {
  handleChartFieldChange,
} from '../reducers/chartFormReducer'

import {
  handleAntibioticsUseChartFieldChange,
  submitChartAntibioticsUse,
  toggleGnbiMicrobiologyRepeated,
  // toggleDeviceRemovedOrReplaced,
  togglePatientWasAdmittedToICU,
  togglePatientExperiencedAdverseEvents,
  addCefiderocolAdverseEvent,
  togglePatientReceivedAdditionalAntimicrobials,
  addAdditionalAntimicrobial,
  togglePatientBodyWeightModal,
 } from '../reducers/antibioticsUseFormReducer'
//  import { toggleScreeningFailure } from '../reducers/chartFormReducer'

import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'
import FormInput from '../../../components/FormInput'
import WarningModal from '../../../components/WarningModal'
import InfoIconOverlay from '../../../components/InfoIconOverlay'

import CefiderocolAdverseEvents from './CefiderocolAdverseEvents'
import AdditionalAntimicrobials from './AdditionalAntimicrobials'
import ICUAdmissionList from './ICUAdmissionList'



const AntibioticsUseForm = (props) => {

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleAntibioticsUseChartFieldChange(name, value)
  }

  const handleReasonToStartChange = (e) => {
    const { name, value } = e.target
    props.handleAntibioticsUseChartFieldChange(name, value)
    if (name !== 'reasonToStartCefiderocolOtherText') {
      props.handleAntibioticsUseChartFieldChange('reasonToStartCefiderocolOtherText', '')
    }
  }

  const handleRecommendedByChange = (e) => {
    const { name, value } = e.target
    props.handleAntibioticsUseChartFieldChange(name, value)
    if (name === 'cefiderocolRecommendedBy') {
      props.handleAntibioticsUseChartFieldChange('cefiderocolRecommendedByOtherText', '')
      props.handleAntibioticsUseChartFieldChange('attendingPhysicianSpecialty', '')
    }
  }

  const handleReasonForEndingChange = (e) => {
    const { name, value } = e.target
    props.handleAntibioticsUseChartFieldChange(name, value)
    if (name === 'reasonForEndingCefiderocol') {
      props.handleAntibioticsUseChartFieldChange('reasonForEndingCefiderocolOtherText', '')
    }
  }

  const handleDateChange = (name, date) => {
    props.handleAntibioticsUseChartFieldChange(name, date)
    props.handleChartFieldChange('chartDateErrorMessage', '')
    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const antibioticsUse = {...props, [name]: date, 'chartDateErrorMessage': name}
      return props.submitChartAntibioticsUse(antibioticsUse)
    }
  }

  const handleBlur = (e) => {
    const { name, value } = e.target
    if (name === "patientBodyWeight" && value > 200) {
      togglePatientBodyWeightModal(true)
      return
    }
    return props.submitChartAntibioticsUse(props)
  }

  const getRequired = (key) => {
    let required = true
    if (props[key] !== null) {
      required = false
    }
    return required
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let splitError = chartDateErrorMessage.split('[')[1].split(']')[0]
        let arr = splitError.split('_')
        let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
        let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
        if (key === camelCase || camelCase.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const {
    chartDateErrorMessage,
    reasonToStartCefiderocol,
    cefiderocolInitiationDate,
    cefiderocolInitiationTime,
    cefiderocolRecommendedBy,
    cefiderocolStartingDoseGrams,
    cefiderocolInfusionTimeHours,
    cefiderocolInfusionFrequencyHours,
    patientBodyWeight,
    serumCreatineLevel,
    serumCreatineLevelUnit,
    cefiderocolEndDate,
    reasonForEndingCefiderocol,


    patientReceivedOtherAntimicrobials,

    clinicalAssessmentCefiderocolTreatment,

    gnbiMicrobiologyRepeated,
    gnbiDateOfSampleTest,
    gnbiPathogens,

    // deviceRemovedOrReplaced,
    // deviceRemovedOrReplacedDate,
    patientExperiencedAdverseEvents,
    patientAdmittedToICU,

    chartForReview,

    togglePatientBodyWeightModal,
    displayPatientBodyWeightModal,
  } = props

  const reasonToStartCefiderocolOptions = [
    {value: 'Documented infection'},
    {value: 'Empirical for suspected CR GNBI'},
    {value: 'Salvage treatment because prior antibiotics failed or not tolerated'},
    {value: 'Unsure if empirical or documented'},
    {value: 'Other',
      textFields: [
         {displayName: 'Please Specify', fieldName: 'reasonToStartCefiderocolOtherText' }
      ]
    },
  ]


  const usCefiderocolRecommendedByOptions = [
    {value: 'ID physician'},
    {value: 'Attending physician',
      textFields: [
         {displayName: 'Specify the attending physician’s specialty', fieldName: 'attendingPhysicianSpecialty'}
      ]
    },
    {value: 'Pharm D/Pharmacist'},
    {value: 'Clinical/Medical microbiologist'},
    {value: 'Other',
      textFields: [
         {displayName: 'Please Specify', fieldName: 'cefiderocolRecommendedByOtherText'}
      ]
    },
    {value: 'Unknown'},
  ]

  const euCefiderocolRecommendedByOptions = [
    {value: 'ID physician'},
    {value: "Lead physician, specify physician's specialty",
      textFields: [
         {displayName: 'Please Specify', fieldName: 'attendingPhysicianSpecialty'}
      ]
    },
    {value: 'Pharmacist'},
    {value: 'Clinical/Medical microbiologist'},
    {value: 'Other',
      textFields: [
         {displayName: 'Please Specify', fieldName: 'cefiderocolRecommendedByOtherText'}
      ]
    },
    {value: 'Unknown'},
  ]


  const reasonForEndingCefiderocolOptions = [
    {value: 'Clinical sign-symptoms resolved'},
    {value: 'Clinical failure/infection not resolved'},
    {value: 'Adverse drug reactions'},
    {value: 'Susceptibility test result showed cefiderocol non-susceptible'},
    {value: 'Patient died'},
    {value: 'Palliative Care commenced'},
    {value: 'Switched to alternative susceptible drug(s) including oral drug'},
    {value: 'Other', textFields: [
       {displayName: 'Please Specify', fieldName: 'reasonForEndingCefiderocolOtherText' }
    ]},
  ]


  const clinicalAssessmentCefiderocolTreatmentOptions = [
    {value: 'Resolved'},
    {value: 'Improved'},
    {value: 'Once resolved or improved on cefiderocol treatment, then relapsed after end of cefiderocol treatment'},
    {value: 'Failure (including death due to the indicated GNBI) at end of cefiderocol treatment'},
    {value: 'Unknown'},
  ]

  const serumCreatineLevelUnitOptions = [
    {value: 'mg/dL'},
    {value: 'mg/L'},
    {value: 'µmol/L'},
    {value: 'mol/L'},
    {value: 'mmol/L'},
  ]

  const numberOnlyInfoText = 'Enter a number only. Do not enter units in this field.'

  return (
    <div id="AntibioticsUseForm">
      <WarningModal
        show={displayPatientBodyWeightModal}
        onHide={() => togglePatientBodyWeightModal(false)}
        headerText="Patient Body Weight Validation"
        bodyText={`You entered ${patientBodyWeight} kg. Are you sure this is correct?`}
        onConfirm={() => {
          props.handleAntibioticsUseChartFieldChange("patientBodyWeight", patientBodyWeight)
          props.submitChartAntibioticsUse(props)
          togglePatientBodyWeightModal(false)
        }}
        onCancel={() => {
          props.handleAntibioticsUseChartFieldChange("patientBodyWeight", "")
          props.submitChartAntibioticsUse(props)
          togglePatientBodyWeightModal(false)
        }}
      />
      {/* <Modal dialogClassName="modal-wide" show={displayPatientBodyWeightModal} onHide={() => togglePatientBodyWeightModal(false)}>
        <Modal.Header closeButton>Patient Body Weight Validation</Modal.Header>
        <Modal.Body>You entered {patientBodyWeight} kg. Are you sure this is correct?</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => {
            props.handleAntibioticsUseChartFieldChange("patientBodyWeight", patientBodyWeight)
            props.submitChartAntibioticsUse(props)
            togglePatientBodyWeightModal(false)
          }} variant="primary">Yes</Button>
          <Button onClick={() => {
            props.handleAntibioticsUseChartFieldChange("patientBodyWeight", "")
            props.submitChartAntibioticsUse(props)
            togglePatientBodyWeightModal(false)
          }} variant="secondary">No</Button>
        </Modal.Footer>
      </Modal> */}
      <Form validated={props.chartIsIncompleteModalData.length !== 0 ? true : false}>
        <SelectWithOptionalTextField
          label='Reason to start cefiderocol'
          options={reasonToStartCefiderocolOptions}
          selected={reasonToStartCefiderocol}
          selectFieldName='reasonToStartCefiderocol'
          handleChange={handleReasonToStartChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          infoText="Documented infection refers to use of CFDC when the pathogen and susceptibilites are known and not due to failure of a prior antibiotic regimen. It may be given in combination with another antibiotic. Empirical use refers to its use before the pathogen and/or susceptibilities are available to help guide the choice. Salvage refers to the use of CFDC after a prior antibiotic regimen has not worked. It usually requires at least 3 days of the prior therapy to see if there is an adequate response before the next course would be considered salvage."
          {...props}
        />
        
        {userRegionIsUS(props.currentUser)
          ?
            <SelectWithOptionalTextField
              label='Who recommended cefiderocol'
              options={usCefiderocolRecommendedByOptions}
              selected={cefiderocolRecommendedBy}
              selectFieldName='cefiderocolRecommendedBy'
              handleChange={handleRecommendedByChange}
              onBlur={handleBlur}
              disabled={chartForReview}
              placeholder="Please make a selection"
              required={true}
              {...props}
            />
          :
            null
        }

        {userRegionIsEU(props.currentUser)
          ?
            <SelectWithOptionalTextField
              label='Who recommended cefiderocol'
              options={euCefiderocolRecommendedByOptions}
              selected={cefiderocolRecommendedBy}
              selectFieldName='cefiderocolRecommendedBy'
              handleChange={handleRecommendedByChange}
              onBlur={handleBlur}
              disabled={chartForReview}
              placeholder="Please make a selection"
              required={true}
              {...props}
            />
          :
            null
        }
        
        
        

       <FormInput
          label="Date when cefiderocol was initiated"
          type='date'
          value={cefiderocolInitiationDate}
          onChange={(date) => handleDateChange('cefiderocolInitiationDate', date)}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={true}
          errorText={getHelperText('cefiderocolInitiationTime')}
        />

       <FormInput
          label="Time when cefiderocol was initiated"
          type='time'
          value={cefiderocolInitiationTime}
          onChange={(date) => handleDateChange('cefiderocolInitiationTime', date)}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={false}
          errorText={getHelperText('cefiderocolInitiationDate')}
        />

        <FormInput
           label="Cefiderocol starting dose (grams)"
           type='number'
           name='cefiderocolStartingDoseGrams'
           value={cefiderocolStartingDoseGrams}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Please enter the starting dose in grams'
           disabled={chartForReview}
           infoText={numberOnlyInfoText}
           required={true}
         />

        <FormInput
           label="Cefiderocol infusion time (hours)"
           type='number'
           name='cefiderocolInfusionTimeHours'
           value={cefiderocolInfusionTimeHours}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Please enter the infusion time in hours'
           disabled={chartForReview}
           infoText='Enter the duration of cefiderocol infusion in number of hours. Please enter only the number of hours and do not include units.'
           required={true}
         />

        <FormInput
           label="Cefiderocol frequency (hours)"
           type='number'
           name='cefiderocolInfusionFrequencyHours'
           value={cefiderocolInfusionFrequencyHours}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Please enter the frequency in hours'
           disabled={chartForReview}
           infoText='Enter the number of hours between the start of each infusion. For example, if infusions are given 3 times daily, the number of hours between the start of each infusion is 8. Please enter only the number of hours and do not include units.'
           required={true}
         />

        <FormInput
           label="Patient body weight (kg)"
           type='number'
           name='patientBodyWeight'
           value={patientBodyWeight}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder="Please enter the patient's body weight in kg"
           disabled={chartForReview}
           infoText={numberOnlyInfoText}
           required={true}
         />

        <FormInput
           label="Serum creatinine level"
           type='number'
           name='serumCreatineLevel'
           value={serumCreatineLevel}
           onChange={handleChange}
           onBlur={handleBlur}
           placeholder='Please enter the serum creatinine level'
           disabled={chartForReview}
           infoText={numberOnlyInfoText}
           required={true}
         />

        <SelectWithOptionalTextField
          label='Serum creatinine level units'
          options={serumCreatineLevelUnitOptions}
          selected={serumCreatineLevelUnit}
          selectFieldName='serumCreatineLevelUnit'
          handleChange={handleChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />

        <FormInput
           label="Date when cefiderocol was discontinued"
           type='date'
           value={cefiderocolEndDate}
           onChange={(date) => handleDateChange('cefiderocolEndDate', date)}
           onBlur={handleBlur}
           disabled={chartForReview}
           required={true}
           errorText={getHelperText('cefiderocolEndDate')}
         />

        <SelectWithOptionalTextField
          label='Primary reason why cefiderocol was discontinued'
          options={reasonForEndingCefiderocolOptions}
          selected={reasonForEndingCefiderocol}
          selectFieldName='reasonForEndingCefiderocol'
          handleChange={handleReasonForEndingChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          infoText={`Sometimes CFDC may be stopped for a suspected ADR even if later it has been determined not to be an  ADR. This should be classified as "other" with a follow-up explanation in free text`}
          {...props}
        />


        <Form.Label>
          Did the patient receive other systemic Gram-negative or Gram-positive antimicrobials or antifungals (not topical) for the treatment of the indicated GNBI for ≥2 days with a starting time within 14 days of starting cefiderocol up to and including 3 days after cefiderocol was stopped?
          <InfoIconOverlay
            text={
              <>
                <span>
                  {`Only oral or IV treatments are included. Other types of treatments, such as nebulizers or nasal lavage, do not need to be entered.`}
                </span>
                <br />
                <br />
                <span>
                  {`If any day of the treatment overlapped with the window of interest (14 days prior to starting cefiderocol up to and including 3 days after cefiderocol was stopped) but had a start date of >14 days prior to starting cefiderocol, please list the start date of the treatment as being 14 days prior to starting cefiderocol.`}
                </span>
              </>
            }
          />
        </Form.Label>

        <Form.Check
          id="patientDidNotReceiveOtherAntimicrobials"
          name="patientDidNotReceiveOtherAntimicrobials"
          label='No'
          type='radio'
          checked={patientReceivedOtherAntimicrobials === false}
          onBlur={handleBlur}
          onChange={() => props.togglePatientReceivedAdditionalAntimicrobials(!patientReceivedOtherAntimicrobials, props)}
          disabled={chartForReview}
          required={getRequired('patientReceivedOtherAntimicrobials')}
        />

        <Form.Check
          id="patientReceivedOtherAntimicrobials"
          name="patientReceivedOtherAntimicrobials"
          label='Yes'
          type='radio'
          checked={patientReceivedOtherAntimicrobials === true}
          onBlur={handleBlur}
          onChange={() => props.togglePatientReceivedAdditionalAntimicrobials(!patientReceivedOtherAntimicrobials, props)}
          disabled={chartForReview}
          required={getRequired('patientReceivedOtherAntimicrobials')}
        />


        {patientReceivedOtherAntimicrobials === true ?
          <AdditionalAntimicrobials chartForReview={chartForReview} />
          :
          null
        }

        <br/>

        <SelectWithOptionalTextField
          label='Overall assessment of the clinical benefit of cefiderocol treatment on the indicated GNBI. What were the signs and symptoms of the indicated GNBI at the end of cefiderocol?'
          options={clinicalAssessmentCefiderocolTreatmentOptions}
          selected={clinicalAssessmentCefiderocolTreatment}
          selectFieldName='clinicalAssessmentCefiderocolTreatment'
          handleChange={handleChange}
          onBlur={handleBlur}
          disabled={chartForReview}
          placeholder="Please make a selection"
          required={true}
          {...props}
        />

        <Form.Label>
          At the discontinuation of cefiderocol treatment or within 7 days of the discontinuation, was the microbiology repeated for the indicated GNBI for which cefiderocol was used?
        </Form.Label>
        <Form.Check
          id='gnbiMicrobiologyNotRepeated'
          name='gnbiMicrobiologyNotRepeated'
          label='No'
          type='radio'
          checked={gnbiMicrobiologyRepeated === false}
          onBlur={handleBlur}
          onChange={(e) => props.toggleGnbiMicrobiologyRepeated(!gnbiMicrobiologyRepeated)}
          disabled={chartForReview}
          required={getRequired('gnbiMicrobiologyRepeated')}
        />

        <Form.Check
          id="gnbiMicrobiologyRepeated"
          name="gnbiMicrobiologyRepeated"
          label='Yes'
          type='radio'
          checked={gnbiMicrobiologyRepeated === true}
          onBlur={handleBlur}
          onChange={(e) => props.toggleGnbiMicrobiologyRepeated(!gnbiMicrobiologyRepeated)}
          disabled={chartForReview}
          required={getRequired('gnbiMicrobiologyRepeated')}
        />

        {gnbiMicrobiologyRepeated === true ?
          <>
            <div className="indented-row">
              <FormInput
                label="Date of the test of sample from the same source as the indicated GNBI:"
                xs={12}
                sm={12}
                md={12}
                lg={12}
                timeIn
                type='date'
                name='gnbiDateOfSampleTest'
                value={gnbiDateOfSampleTest}
                onChange={(date) => handleDateChange('gnbiDateOfSampleTest', date)}
                onBlur={handleBlur}
                disabled={chartForReview}
                required={true}
                errorText={getHelperText('gnbiDateOfSampleTest')}
              />

              <FormInput
                label={'Pathogen(s) identified'}
                name={'gnbiPathogens'}
                placeholder={'Enter pathogen(s)'}
                value={gnbiPathogens}
                type={'textarea'}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={chartForReview}
                required={true}
              />
            </div>
           </>
           :
           null
        }

        <br/>


        {/* <Form.Label>
          If the source of the indicated GNBI is known (such as central line, ventilator, prosthetic, abscess, etc.), was the device or source removed, drained, or otherwise addressed?
        </Form.Label>
        <Form.Check
          id="deviceNotRemovedOrReplaced"
          name="deviceNotRemovedOrReplaced"
          label='No'
          type='radio'
          checked={deviceRemovedOrReplaced === false}
          onBlur={handleBlur}
          onChange={(e) => props.toggleDeviceRemovedOrReplaced(!deviceRemovedOrReplaced)}
          disabled={chartForReview}
          required={getRequired('deviceRemovedOrReplaced')}
        />

        <Form.Check
          id="deviceRemovedOrReplaced"
          name="deviceRemovedOrReplaced"
          label='Yes'
          type='radio'
          checked={deviceRemovedOrReplaced === true}
          onBlur={handleBlur}
          onChange={(e) => props.toggleDeviceRemovedOrReplaced(!deviceRemovedOrReplaced)}
          disabled={chartForReview}
          required={getRequired('deviceRemovedOrReplaced')}
        />


        {deviceRemovedOrReplaced === true ?
          <FormInput
             label="When was the device removed or replaced?"
             type='date'
             name='deviceRemovedOrReplacedDate'
             value={deviceRemovedOrReplacedDate}
             onChange={(date) => handleDateChange('deviceRemovedOrReplacedDate', date)}
             onBlur={handleBlur}
             disabled={chartForReview}
             required={true}
             errorText={getHelperText('deviceRemovedOrReplacedDate')}
           />
           :
           null
        }

        <br/> */}

        <Form.Label>
          Had treating physicians documented any adverse drug reactions related to cefiderocol treatment from starting the cefiderocol to the 30 days after the last cefiderocol dose or end of the hospitalization if it occurred before the 30 days of the last dose?
        </Form.Label>
        <Form.Check
          id="patientDidNotExperienceAdverseEvents"
          name="patientDidNotExperienceAdverseEvents"
          label='No'
          type='radio'
          checked={patientExperiencedAdverseEvents === false}
          onBlur={handleBlur}
          onChange={(e) => props.togglePatientExperiencedAdverseEvents(!patientExperiencedAdverseEvents, props)}
          disabled={chartForReview}
          required={getRequired('patientExperiencedAdverseEvents')}
        />

        <Form.Check
          id="patientExperiencedAdverseEvents"
          name="patientExperiencedAdverseEvents"
          label='Yes'
          type='radio'
          checked={patientExperiencedAdverseEvents === true}
          onBlur={handleBlur}
          onChange={(e) => props.togglePatientExperiencedAdverseEvents(!patientExperiencedAdverseEvents, props)}
          disabled={chartForReview}
          required={getRequired('patientExperiencedAdverseEvents')}
        />

        {patientExperiencedAdverseEvents === true ?
          <CefiderocolAdverseEvents chartForReview={chartForReview} alert={props.alert}/>
          :
          null
        }

        <br />

        <Form.Label>
          Did patient spend any time in an ICU setting while on cefiderocol during the hospitalization?
        </Form.Label>
        <Form.Check
          id="patientNotAdmittedToICU"
          name="patientNotAdmittedToICU"
          label='No'
          type='radio'
          checked={patientAdmittedToICU === false}
          onBlur={handleBlur}
          onChange={(e) => props.togglePatientWasAdmittedToICU(!patientAdmittedToICU, props)}
          disabled={chartForReview}
          required={getRequired('patientAdmittedToICU')}
        />

        <Form.Check
          id="patientAdmittedToICU"
          name="patientAdmittedToICU"
          label='Yes'
          type='radio'
          checked={patientAdmittedToICU === true}
          onBlur={handleBlur}
          onChange={(e) => props.togglePatientWasAdmittedToICU(!patientAdmittedToICU, props)}
          disabled={chartForReview}
          required={getRequired('patientAdmittedToICU')}
        />

        {patientAdmittedToICU === true ?
          <ICUAdmissionList chartForReview={chartForReview} alert={props.alert}/>
         :
         null
        }

        <br/>
        <br/>

      </Form>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    antibioticsUseInfoUrl: state.antibioticsUseFormReducer.antibioticsUseInfoUrl,
    reasonToStartCefiderocol: state.antibioticsUseFormReducer.reasonToStartCefiderocol,
    reasonToStartCefiderocolOtherText: state.antibioticsUseFormReducer.reasonToStartCefiderocolOtherText,
    cefiderocolInitiationDate: state.antibioticsUseFormReducer.cefiderocolInitiationDate,
    cefiderocolInitiationTime: state.antibioticsUseFormReducer.cefiderocolInitiationTime,
    cefiderocolRecommendedBy: state.antibioticsUseFormReducer.cefiderocolRecommendedBy,
    cefiderocolRecommendedByOtherText: state.antibioticsUseFormReducer.cefiderocolRecommendedByOtherText,
    attendingPhysicianSpecialty: state.antibioticsUseFormReducer.attendingPhysicianSpecialty,
    cefiderocolStartingDoseGrams: state.antibioticsUseFormReducer.cefiderocolStartingDoseGrams,
    cefiderocolInfusionTimeHours: state.antibioticsUseFormReducer.cefiderocolInfusionTimeHours,
    cefiderocolInfusionFrequencyHours: state.antibioticsUseFormReducer.cefiderocolInfusionFrequencyHours,
    patientBodyWeight: state.antibioticsUseFormReducer.patientBodyWeight,
    displayPatientBodyWeightModal: state.antibioticsUseFormReducer.displayPatientBodyWeightModal,
    serumCreatineLevel: state.antibioticsUseFormReducer.serumCreatineLevel,
    serumCreatineLevelUnit: state.antibioticsUseFormReducer.serumCreatineLevelUnit,
    cefiderocolEndDate: state.antibioticsUseFormReducer.cefiderocolEndDate,
    reasonForEndingCefiderocol: state.antibioticsUseFormReducer.reasonForEndingCefiderocol,
    reasonForEndingCefiderocolOtherText: state.antibioticsUseFormReducer.reasonForEndingCefiderocolOtherText,


    patientReceivedOtherAntimicrobials: state.antibioticsUseFormReducer.patientReceivedOtherAntimicrobials,
    clinicalAssessmentCefiderocolTreatment: state.antibioticsUseFormReducer.clinicalAssessmentCefiderocolTreatment,

    gnbiMicrobiologyRepeated: state.antibioticsUseFormReducer.gnbiMicrobiologyRepeated,
    gnbiDateOfSampleTest: state.antibioticsUseFormReducer.gnbiDateOfSampleTest,
    gnbiPathogens: state.antibioticsUseFormReducer.gnbiPathogens,


    // deviceRemovedOrReplaced: state.antibioticsUseFormReducer.deviceRemovedOrReplaced,
    // deviceRemovedOrReplacedDate: state.antibioticsUseFormReducer.deviceRemovedOrReplacedDate,
    patientExperiencedAdverseEvents: state.antibioticsUseFormReducer.patientExperiencedAdverseEvents,

    patientAdmittedToICU: state.antibioticsUseFormReducer.patientAdmittedToICU,

    cefiderocolAdverseEvents: state.antibioticsUseFormReducer.cefiderocolAdverseEvents,
    additionalAntimicrobials: state.antibioticsUseFormReducer.additionalAntimicrobials,
    icuAdmissions: state.antibioticsUseFormReducer.icuAdmissions,
    displayAntibioticsScreeningFailure: state.antibioticsUseFormReducer.displayAntibioticsScreeningFailure,
  }
}

const mapDispatchToProps = {
  handleAntibioticsUseChartFieldChange,
  submitChartAntibioticsUse,
  toggleGnbiMicrobiologyRepeated,
  // toggleDeviceRemovedOrReplaced,
  togglePatientWasAdmittedToICU,
  togglePatientExperiencedAdverseEvents,
  togglePatientBodyWeightModal,
  // toggleScreeningFailure,
  addCefiderocolAdverseEvent,
  togglePatientReceivedAdditionalAntimicrobials,
  addAdditionalAntimicrobial,
  handleChartFieldChange,
}


export default connect(mapStateToProps, mapDispatchToProps)(AntibioticsUseForm)
